export enum GCJustificationTypeEnum {
  DontUse = 'Não',
  NoSale = 'Não Venda',
  BuyUnderRange = 'Compra a Menor',
}
